import React from 'react';
import { motion } from 'framer-motion';
import { ReactTyped } from 'react-typed';
import { FaLinkedin, FaGithub, FaArrowDown, FaDownload } from 'react-icons/fa';
import { Link } from 'react-scroll';
import { proofStrip, contact, about } from '../content/data';

const Hero = () => {
  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-start relative overflow-hidden"
    >
              <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-left"
          >
            <h1 className="text-5xl md:text-8xl font-bold mb-6">
              Hi I'm{' '}
              <span className="bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
              <ReactTyped
                strings={["Chris.", "a student.", "a developer."]}
                typeSpeed={70}
                backSpeed={60}
                loop={true}
              />
            </span>
            </h1>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
              className="text-2xl md:text-3xl text-gray-400 mb-8"
            >
              My name is Christopher Tengey, and I am a senior at Georgetown University studying Computer Science and Mathematics. I am passionate about software development, data science, and machine learning.
            </motion.p>
            <motion.div 
              className="flex justify-start space-x-6"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
            <div className="flex justify-center space-x-6">
              <a href="https://www.linkedin.com/in/christopher-tengey-12555b24a/" className="text-5xl hover:text-blue-500 transition-colors">
                <FaLinkedin />
              </a>
              <a href="https://github.com/chrisdten3" className="text-5xl hover:text-purple-500 transition-colors">
                <FaGithub />
              </a>
            </div>
            </motion.div>
          </motion.div>
        </div>
    </section>
  );
};

export default Hero;
